export { default } from './OmiseAlipay'



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/OmiseAlipay/index.js